exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1pG_6{text-align:center;padding:var(--b-space)}._14pX_{width:auto}", ""]);

// exports
exports.locals = {
	"container": "_1pG_6",
	"logo": "_14pX_"
};